<li class="nav-item mr-25">
  <a class="nav-link" [routerLink]="['/notifications']">
    <i class="ficon" data-feather="bell"></i>
    @if (unreadCount > 0) {
      <span class="badge badge-pill badge-danger badge-up">{{ unreadCount }}</span>
    }
  </a>
</li>
